import React from 'react';
import './Profile.scss';

import UpdateProfile from '../UpdateProfile/UpdateProfile';

const Profile = () => {
  return <div className="profile">
    <UpdateProfile />
  </div>;
};

export default Profile;